import { useState } from 'react';

import LinkIcon from '@mui/icons-material/Link';
import { Grid, Typography } from '@mui/material';
import { Button, Confirm, HttpError, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { LinkAccountBodyDto } from 'src/dtos';
import { HttpErrorTypography } from 'src/lib';
import { BaseAccount } from 'src/models';

export const LinkAccountButton = ({ account, rootAccountId }: { account?: BaseAccount; rootAccountId?: string }) => {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const [linkAccount, { isError, error, isLoading, reset }] = useUpdate<
    Partial<LinkAccountBodyDto> & { id: string },
    HttpError
  >();

  const onConfirm = () => {
    linkAccount(
      DataProviderResource.LinkAccount,
      {
        id: rootAccountId,
        data: {
          id: account?.id,
          primaryAccountHolder: {
            ssid: account?.primaryAccountHolder?.ssid,
            dateOfBirth: account?.primaryAccountHolder?.dateOfBirth,
          },
        },
      },
      {
        mutationMode: 'pessimistic',
        onSuccess: () => {
          notify(`Account was successfully linked.`, {
            type: 'success',
            undoable: true,
          });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
    reset();
  };

  return (
    <>
      <Button
        label='Link'
        onClick={() => setIsOpen(true)}
        startIcon={<LinkIcon />}
        disabled={account?.linkStatus.isPendingCreate || account?.linkStatus.isLinked}
      />
      <Confirm
        isOpen={isOpen}
        title='Link Account'
        content={
          <Grid container direction='column' spacing={2}>
            <Grid item md={12} sm={12}>
              <Typography variant='body1'>Are you sure you want to link {account?.customTypeLabel} account?</Typography>
              {isError && <HttpErrorTypography error={error} />}
            </Grid>
          </Grid>
        }
        onConfirm={onConfirm}
        onClose={onClose}
        loading={isLoading}
      />
    </>
  );
};
